<template>
  <div id="pane-wrap" class="right-pane border-dark " v-bind:class="{'iphone': iOS, 'right-pane-desktop': nakdanStyle.Desktop, 'right-pane-mobile': nakdanStyle.Mobile}" v-hotkey="keymap">
    <textarea 
      class="main-input-box text-right" 
      id="text-wrap"
      v-model="areaText"
      @change="updateStore"
      @focus="hideHeader"
      @focusout ="showHeader"
      placeholder="הזן טקסט כאן" />
    <div class="clear-main-input-div" v-show="areaText.length" @click="areaText=''"><i-times /></div>
    <form ref="fileForm" v-if="allowDocumentLoad">
      <label for="file-input" class="bottom-button load-button btn btn-secondary"><i-file></i-file> העלה קובץ</label>
      <input type="file" name="name" id="file-input" class="inputfile inputfile-2 d-none" ref="inputEl" @change="loadInputtedFile">
    </form>
    <div v-if="nakdanRunnerInMainInput" class="bottom-button nakdan-runner-div">
      <nakdan-runner :options="$store.state.preSubmissionOptions" />
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import {loadWordDocFromArrayBuffer} from '@/js/wordImportExport'
import $ from 'jquery'
import {NakdanStyle, MobileVsDesktopConfig} from '@/mobileVsDesktopConfig.js'
import NakdanRunner from './NakdanRunner'

var READABLE_TYPES = {
  text: 'text/plain',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
}

export default {
  name: 'MainInput',
  components: {
    NakdanRunner
  },
  data () {
    return {
      areaText: "",
      iOS: false,
      displayPromotions: false
    }
  },
  computed: {
    nakdanStyle () {
      return NakdanStyle // Mobile: window.innerWidth < 992, Desktop: window.innerWidth >= 992
    },
    allowDocumentLoad () {
      return MobileVsDesktopConfig.ALLOW_DOCUMENT_LOAD
    },
    nakdanRunnerInMainInput () {
      return !(MobileVsDesktopConfig.DOCUMENT_SETTINGS_PANE)
    },
    keymap () {
      return {
        'ctrl+enter': () => { document.activeElement.blur() }
      }
    }
  },
  methods: {
    hideHeader () {
      if(this.iOS) {
        document.getElementById('pane-wrap').classList.add('focused')
        document.getElementById('home-header').classList.add('d-none')
        var promotions = document.getElementsByClassName("promotion") != null
        if (promotions) {
          document.getElementById('promotions').classList.add('d-none')
        }  
        document.getElementsByTagName('footer')[0].classList.add('d-none')
      }
    },
    showHeader () {
      if(this.iOS) {
          document.getElementById('pane-wrap').classList.remove('focused')
          document.getElementById('home-header').classList.remove('d-none')
          document.getElementsByTagName('footer')[0].classList.remove('d-none')
          var promotions = document.getElementsByClassName("promotion") != null
          if (promotions) {
            document.getElementById('promotions').classList.remove('d-none')
          }
      }      
    },
    updateStore () {
      this.$store.commit('EDIT_DOCUMENT_TEXT', {text: this.areaText, nullifySource: true})
    },
    loadInputtedFile () {
      var f = this.$refs.inputEl.files[0]
      // console.log('f.type:')
      // console.log(f.type)
      // if there is a file available and it is a type we support
      if (f && Object.values(READABLE_TYPES).includes(f.type)) {
        // set up a FileReader, which reads files asynchronously. It fires an onload event when the file is read.
        var r = new FileReader()
        r.onload = (e) => {
          // alert( "Got the file\n" 
          //    +"name: " + f.name + "\n"
          //    +"type: " + f.type + "\n"
          //    +"size: " + f.size + " bytes\n"
          //    + "starts with: " + contents.substr(1, contents.indexOf("\n"))
          // );
          var contents = e.target.result
          var docText = contents
          let source
          if (f.type === READABLE_TYPES.docx) {
            // console.log('binary contents:')
            // console.log(contents)
            const results = loadWordDocFromArrayBuffer(contents)
            docText = results.text
            source = results.source
          } else source = {
            fileBase64Contents: null,
            type: 'text',
            runArray: [],
            wordToRunAndPosMap: []        
          }
          // saves information about the source file
          this.$store.commit('LOAD_DOCUMENT_FILE', source)
          // updates the text in the store - this is a separate commit because it also applies to direct text entry, not just files
          this.$store.commit('EDIT_DOCUMENT_TEXT', {text: docText, nullifySource: false})
          this.areaText = docText
          this.$refs.fileForm.reset()
        }
        // actually start the file read, which will eventually fire the onload event
        // readAsArrayBuffer is used for Word files
        if (f.type === READABLE_TYPES.text) { r.readAsText(f) } else r.readAsArrayBuffer(f)
      } else { 
        alert("Failed to load file")
      }
    }
  },
  destroyed () {
    document.removeEventListener('resize', event, false)
  },
  mounted () {
    if (navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i)) {
      this.iOS = true
      document.body.classList.add('ios-main')
      var winHeight =  window.innerHeight
      window.addEventListener("resize", function() {
        var currentHeight = window.innerHeight    
        if(currentHeight != winHeight) {
          document.body.style.height = window.innerHeight + "px";
          document.body.classList.add('ios-toolbar-gone')
        } else {
          document.body.classList.remove('ios-toolbar-gone')
        }
      }, false);      
    }
    if(!this.iOS && this.nakdanStyle.Mobile){
      $(window).on('resize', function(){
        var promotions = document.getElementsByClassName("promotion") != null
        // If the current active element is a text input, we can assume the soft keyboard is visible.  
        
        if (document.getElementById('text-wrap').clientHeight < 250) {
            document.getElementById('pane-wrap').classList.add('focused')
            document.getElementById('home-header').classList.add('d-none')
            if (promotions) {
              document.getElementById('promotions').classList.add('d-none')
            }
        } else {
          document.getElementById('pane-wrap').classList.remove('focused')
          document.getElementById('home-header').classList.remove('d-none')
          if (promotions) {
            document.getElementById('promotions').classList.remove('d-none')
          }  
          
        }
      })
    }
    if (this.$store.state.originalDocument.text && this.$store.state.originalDocument.text.length) this.areaText = this.$store.state.originalDocument.text
    if (!this.iOS)
      $('.main-input-box').focus()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
/* DocumentSettings-specific CSS goes here */
.right-pane {
  text-align: right;
  border: solid 1px;
  padding: 5px;
  border-radius: 4px;
  position: relative;
  background: #fff;
}
.right-pane-desktop {
  height: 100%;
  width: 100%;
}
.right-pane-mobile {
  margin: 12px;
  height: calc(100% - 130px);
  width: calc(100% - 25px);
  &.focused {
    height: calc(100% - 75px)!important;
  }   
}
.right-pane p {
  color: black;
}

.promotions-displayed{
  .right-pane-mobile {
    height: calc(100% - 210px);
  }
} 

.iphone { 
/* CSS specific to iOS devices */ 
  &.right-pane-mobile {
    height: 76%;
    &.focused{
      height: 50%!important;
    }
  }
}
.promotions-displayed{
  .iphone { 
    &.right-pane-mobile {
      height: calc(76% - 80px);
    }
  }
}
.ios-toolbar-gone {
  .iphone { 
    /* CSS specific to iOS devices */ 
      &.right-pane-mobile {
        height: 87%;
        &.focused{
            height: 54%!important;
        }
      }
  } 
}
.promotions-displayed {
  &.ios-toolbar-gone {
    &.right-pane-mobile {
      height: calc(87% - 80px);
    }
  }
}

.main-input-box {
  height: calc(100% - 40px);
  width: 100%;
  font-family: mft_narkisclassic, serif;
  font-size: 25px;
  line-height: 30px;
  border-style: none;
  resize: none;
  padding: 6px 6px 6px 39px;
}
.main-input-box:focus {
  outline: none;
}
.right-pane:focus-within {
  border-color: var(--primary) !important;
}
.bottom-button {
  position: absolute;
  bottom: 10px;
  margin-bottom: 0;
}
.load-button {
  right: 15px;
}
.nakdan-runner-div {
  left: 0px;
  bottom: 0px !important;
}
.clear-main-input-div {
  position: absolute; 
  top: 12px; 
  left: 13px;
  height: 23px;
  width: 22px;
  text-align: center;
  cursor: pointer;
}
</style>
